import * as openpgp from 'openpgp'

const encrypt = async (data: string, secretKey: string) => {
  const message = await openpgp.createMessage({ text: data })
  const encrypted = await openpgp.encrypt({
    message,
    passwords: [secretKey],
    format: 'armored',
  })
  return encrypted as string
}

export default encrypt
